:host {
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
